import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


const AddPackage = () => {
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })

    const [packageName, setpackageName] = useState('');
    const [serviceID, setServiceID] = useState('');
    const [serviceData, setServiceData] = useState([]);
    // const Navigate = useNavigate();

    const addServiceApi = () => {
        console.log(packageName);
        Axios
            .post("api/bussiness/services-package", {
                package_name: packageName,
                service_id: serviceID
            })
            .then((response) => {
                setpackageName('');
                setServiceID('');
                setNotify({
                    isOpen: true,
                    messsage: "Added Successfully",
                    type: 'success'
                })
            }).catch((error) => {
                setNotify({
                    isOpen: true,
                    messsage: "already exits service",
                    type: 'warning'
                })
            });
    }

    const serviceApi = async (e) => {
        Axios
            .get(`/api/bussiness/get-plan-service-data`, {
            }).then((response) => {
                console.log(response);
                console.log(response.data.data.PlanServiceList[0])
                setServiceData(response.data.data.PlanServiceList[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
        console.log(serviceID);
    }
    const serviceList = serviceData.map((list) => {
        return (
            <option key={list.service_id} value={list.service_id}> {list.service_name} </option>
        )
    })


    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Add Package</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%", marginTop: "10px" }}>

                                <div className="form-group mb-3">
                                    <label htmlFor="service">Select Services</label>
                                    <select
                                        onChange={(e) => { setServiceID(e.target.value) }}
                                        id="service"
                                        type="text"
                                        className="form-control"
                                        onClick={serviceApi}
                                        style={{
                                            height: "50px", width: "100%"
                                        }}>
                                        <option>Select Services</option>
                                        {serviceList}
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="group-name">Package Name</label>
                                    <input
                                        onChange={(e) => setpackageName(e.target.value)}
                                        id="group-name"
                                        value={packageName}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter package name"
                                    />

                                </div>
                                <button onClick={addServiceApi} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                            </div>
                            {
                                notify.isOpen ?
                                    <Notification
                                        notify={notify}
                                        setNotify={setNotify} />
                                    : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPackage;